<template>
	<div class="form-model-main">
		<div class="add-page-content">
			<div class="title">{{modelTitle}}</div>
			<div class="content">
				<a-form>
					<a-row class="input-row">
						<a-col>
							<a-form-item :validate-status="isSubmit&&!formData.deptName?'error':''"
							             :help="isSubmit&&!formData.deptName?'请输入组织名称':''">
								<div class="name hospital-required">组织名称</div>
								<div>
									<a-input v-model="formData.deptName" placeholder="请输入组织名称"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col>
							<a-form-item :validate-status="isSubmit&&!formData.parentId?'error':''"
							             :help="isSubmit&&!formData.parentId?'请输入选择组织':''">
								<div class="name hospital-required">上级组织</div>
								<div>
									<a-tree-select
											:getPopupContainer="triggerNode => triggerNode.parentNode"
											v-model="formData.parentId"
											@change="onChange"
											allowClear
											searchPlaceholder='请选择'>
										<a-tree-select-node value="1" title="顶级" key="1"></a-tree-select-node>
										<a-tree-select-node v-for="(item) in treeData"
										                    :value="item.deptId"
										                    :title="item.deptName"
										                    :key="item.deptId">
										</a-tree-select-node>
									</a-tree-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name hospital-required">是否接口对接</div>
								<div class="form-radio">
									<a-radio-group v-model="formData.isInterfaceDocking">
										<a-radio :value="0">否</a-radio>
										<a-radio :value="1">是</a-radio>
									</a-radio-group>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item v-if="formData.isInterfaceDocking == 1">
								<div class="name hospital-required">接口标示</div>
								<div>
									<a-select v-model="formData.msgFrom" placeholder="请选择">
										<a-select-option value="0">fou0</a-select-option>
										<a-select-option value="1">shi1</a-select-option>
									</a-select>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormInput">
						<a-col>
							<a-form-item :validate-status="isSubmit&&!formData.hospitalAddress?'error':''"
							             :help="isSubmit&&!formData.hospitalAddress?'请输入医院地址':''">
								<div class="name hospital-required">医院地址</div>
								<div>
									<a-input v-model="formData.hospitalAddress" @blur="getGeoCoding"
									         placeholder="请输入医院地址"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormInput">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.hospitalCity?'error':''"
							             :help="isSubmit&&!formData.hospitalCity?'请输入城市':''">
								<div class="name hospital-required">城市</div>
								<div>
									<a-input v-model="formData.hospitalCity" placeholder="请输入城市"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.hospitalCode?'error':''"
							             :help="isSubmit&&!formData.hospitalCode?'请输入代号':''">
								<div class="name hospital-required">代号</div>
								<div>
									<a-input v-model="formData.hospitalCode" placeholder="请输入代号"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-else-if="isVisibleFormInputCode">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.hospitalCode?'error':''"
							             :help="isSubmit&&!formData.hospitalCode?'请输入代号':''">
								<div class="name hospital-required">代号</div>
								<div>
									<a-input v-model="formData.hospitalCode" placeholder="请输入代号"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormScanFlag">
						<a-col :span="24">
							<a-form-item :extra="scanPathTips">
								<div class="name">云平台路径</div>
								<div>
									<a-input v-model="formData.scanPath" placeholder="请输入云平台路径"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormInput">
						<a-col class="left" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.hospitalLatitude?'error':''"
							             :help="isSubmit&&!formData.hospitalLatitude?'请输入纬度':''">
								<div class="name hospital-required">地址经纬度</div>
								<div>
									<a-input v-model="formData.hospitalLatitude" placeholder="请输入纬度"/>
								</div>
							</a-form-item>
						</a-col>
						<a-col class="right" :span="12">
							<a-form-item :validate-status="isSubmit&&!formData.hospitalLongitude?'error':''"
							             :help="isSubmit&&!formData.hospitalLongitude?'请输入经度':''">
								<div class="name">&nbsp;</div>
								<div>
									<a-input v-model="formData.hospitalLongitude" placeholder="请输入经度"/>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormInput">
						<a-col :span="24">
							<a-form-item :extra="codeRangeTips">
								<div class="name">协作组条码设置 <span class="code-maxcr">当前最大号段值为：{{maxCRVal}}</span></div>
								<div>
									<a-input v-model="codeRangeStart" placeholder="请输入条码范围"/>
								</div>
							</a-form-item>
						</a-col>
						<!--<a-col class="right" :span="12">-->
						<!--<a-form-item :validate-status="isSubmit&&!isCodeRangeEnd()?'error':''"-->
						<!--:help="isSubmit&&!isCodeRangeEnd()?'请输入起始值为正整数切小于等于18位':''">-->
						<!--<div class="name">&nbsp;</div>-->
						<!--<div>-->
						<!--<a-input v-model="codeRangeEnd" placeholder="请输入一个≤18位的正整数"/>-->
						<!--</div>-->
						<!--</a-form-item>-->
						<!--</a-col>-->
					</a-row>
					<a-row class="input-row" v-if="isVisibleFormInput">
						<a-col class="left" :span="12">
							<a-form-item>
								<div class="name hospital-required">是否协作组医院</div>
								<div class="form-radio">
									<a-radio-group v-model="formData.mapDisplay">
										<a-radio :value="0">否</a-radio>
										<a-radio :value="1">是</a-radio>
									</a-radio-group>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
					<a-row class="input-row">
						<a-col>
							<a-form-item>
								<div class="name">Logo</div>
								<div>
									<a-upload
											name="avatar"
											list-type="picture-card"
											:file-list="fileList"
											:beforeUpload="beforeUpload"
											:multiple="false">
										<img v-if="formData.logoImg" :src="formData.logoImg" alt="avatar"
										     class="logo-img"/>
										<div v-else>
											<a-icon :type="loading ? 'loading' : 'plus'"/>
											<div class="ant-upload-text">
												Upload
											</div>
										</div>
									</a-upload>
								</div>
							</a-form-item>
						</a-col>
					</a-row>
				</a-form>
				<div class="confrim-footer">
					<a-button type="primary" @click="submitDeptForm" class="cf-mr10">确定</a-button>
					<a-button @click="cancelSubmit">取消</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

  import {regAll} from "../../common/validate";

  export default {
    props: {
      deptId: 0,
      deptType: 0,
      deptRow: {
        type: Object,
        default: () => {
        }
      },
    },
    data() {
      return {
        data: [],
        scanPathTips: '云平台路径：请先登录云平台创建好fq路径，此处只填写uesrname之后部分，前后不能有/，如ClinGen/fastq',
        codeRangeTips: '两个数字为1-18位的正整数，用英文“-”分隔，多个号段用英文“,”隔开；如:1-10000,330001-340000',
        formData: {
          deptName: '',
          msgFrom: '',
          isInterfaceDocking: 0,
          deptType: this.deptType,
          parentId: this.deptId,
          hospitalAddress: '',
          hospitalCity: '',
          hospitalCode: '',
          hospitalLatitude: '',
          hospitalLongitude: '',
          codeRange: '',
          logoImg: '',
          mapDisplay: 1,
          scanPath: '',
        },
        codeRangeStart: '',
        codeRangeEnd: '',
        isVisibleFormInput: false,
        isVisibleFormInputCode: false,
        isVisibleFormScanFlag: false,
        treeData: [],
        isSubmit: false,
        isHttpSubmit: false,
        isEdit: false,
        modelTitle: '添加子组织',
        fileList: [],
        loading: false,
        maxCRVal: 0,
      }
    },
    components: {},
    mounted() {
      this.$get("dept/findSelectOptions").then(
        res => {
          this.treeData = res.data.data;
        },
        err => {
          console.log('err', err);
        }
      );
      if (this.formData.parentId == 3) {
        this.isVisibleFormInputCode = true;
        this.isVisibleFormScanFlag = true;
      } else {
        this.isVisibleFormInputCode = false;
        this.isVisibleFormScanFlag = false;
      }
      if (this.formData.parentId == 2) {
        this.isVisibleFormInput = true;
        this.getDeptMaxCR();
      } else {
        this.isVisibleFormInput = false;
      }
      if (JSON.stringify(this.deptRow) != '{}') {
        this.modelTitle = '编辑子组织';
        this.$get('/dept/detail/' + this.deptRow.deptId).then(res => {
          if (res.data.data) {
            this.formData = Object.assign(this.formData, res.data.data);
            this.formData.mapDisplay = this.formData.mapDisplay;
            this.formData.parentId = this.formData.parentId.toString();
            this.formData.isInterfaceDocking = this.formData.isInterfaceDocking ? this.formData.isInterfaceDocking : 0;
            if (this.formData.codeRange && this.formData.codeRange.indexOf('-') != -1) {
              this.codeRangeStart = this.formData.codeRange;
            }
          }
        })
      } else {
        this.modelTitle = '添加子组织';
      }
    },
    methods: {
      getDeptMaxCR() {
        this.$get('dept/maxcr').then(res => {
          this.maxCRVal = res.data.data;
        });
      },
      showLocation(e) {
        const location = e.location;
        this.formData.hospitalLatitude = location.lat;
        this.formData.hospitalLongitude = location.lng;
      },
      getGeoCoding(e) {
        const mapApiUrl = process.env.VUE_APP_GEO_CODING_URL;
        const address = e.target.value;
        const params = {
          address: e.target.value,
          output: 'json',
          ak: 'FrknU0S1Cs2IX2WifjtP71M9wGapEXQD',
          // jsoncallback:'?',
          callback: 'showLocation'
        };
        this.$jsonp(mapApiUrl + "/geocoding/v3/", params).then(res => {
            if (!res.status) {
              this.showLocation(res.result);
            } else {
              this.$message.error("获取医院经纬度失败");
            }
          },
          error => {
            this.$message.error("获取医院经纬度失败");
          });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
      },
      // 上传前事件
      beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('图片格式错误');
          return false;
        }
        this.loading = true;
        if (!file.url && !file.preview) {
          this.getBase64(file).then(res => {
            this.formData.logoImg = res;
            this.loading = false;
          })
        }
        return false;
      },
      isCodeRangeStart() {
        if (this.codeRangeStart) {
          if (!regAll.regCodeRange.test(this.codeRangeStart) || this.codeRangeStart.length > 18) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      isCodeRangeEnd() {
        if (this.codeRangeEnd) {
          if (!regAll.regCodeRange.test(this.codeRangeEnd) || this.codeRangeEnd.length > 18) {
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      onChange(value, opt) {
        let deptType = 0;
        this.formData.parentId = value.toString();
        if (this.formData.parentId == 2) {
          this.isVisibleFormInput = true;
        } else {
          this.isVisibleFormInput = false;
        }
        if (this.treeData && this.treeData.length > 0) {
          this.treeData.forEach((item, index) => {
            if (value == item.deptId) {
              deptType = item.deptType;
            }
          });
        }
        this.formData.deptType = deptType;
      },
      cancelSubmit() {
        this.$emit("close");
      },
      submitDeptForm() {
        this.isSubmit = true;
        this.$nextTick(() => {
          const isPass =
            document.querySelectorAll(".ant-form-explain").length == 0;
          if (isPass) {
            this.isHttpSubmit = true;
            if (this.formData.parentId == 2) {
              this.formData.codeRange = this.codeRangeStart;
            } else if (this.formData.parentId == 3) {
              delete this.formData.hospitalAddress;
              delete this.formData.hospitalCity;
              delete this.formData.hospitalLatitude;
              delete this.formData.hospitalLongitude;
              delete this.formData.codeRange;
            } else if (this.formData.parentId != 2) {
              delete this.formData.hospitalAddress;
              delete this.formData.hospitalCity;
              delete this.formData.hospitalCode;
              delete this.formData.hospitalLatitude;
              delete this.formData.hospitalLongitude;
              delete this.formData.codeRange;
            }
            const method = JSON.stringify(this.deptRow) != '{}' ? '$put' : '$post';
            const mes = JSON.stringify(this.deptRow) != '{}' ? '编辑' : '添加';
            this[method]("dept", this.formData, {
              "Content-Type": "application/json"
            }).then(
              res => {
                this.isHttpSubmit = false;
                if (res.data.code == 0) {
                  this.$message.error(res.data.message);
                } else {
                  this.$message.success(mes + "组织成功！");
                  this.$emit("close");
                }
              },
              error => {
                this.isHttpSubmit = false;
                this.$message.error(mes + "组织失败!");
              }
            );
          }
        });
      },
    },
  }
</script>

<style lang="scss">
	.add-page-content {
		.ant-form-extra {
			word-break: break-all;
		}
		.code-maxcr {
			font-size: 12px;
			margin-left: 20px;
			color: #ff0000;
		}
	}

	.form-radio {
		border: 1px solid #d9d9d9;
		padding-left: 20px;
	}

	.logo-img {
		width: 100%;
	}
</style>